<template>
  <div class="cluster-objects-scroll scroll-fire-fox">
    <span
      v-if="clusterTool && selectedObjects.length > 0"
      class="mb-1 font-weight-bold"
      >Initial Closure:</span
    >

    <div v-for="(object, index) in selectedObjects" :key="object.uuid">
      <div
        class="floating-object-selected"
        :class="{ 'main-closure': index === 0 && clusterTool }"
      >
        <img
          class="floating-img"
          :src="
            require(`@/assets/objectIcons/${object.type.toLowerCase()}.png`)
          "
        />

        <span style="text-align: left; padding-right: 5px">
          {{ objectIdentification(object) }}
        </span>

        <div class="cluster-object-hps" v-if="object.max_hp">
          {{ object.max_hp }}
        </div>
        <div
          v-if="selectionType === 'point' || clusterTool"
          class="floating-hover-options"
          @click="openObjectMenu($event, object)"
        >
          <v-icon>more_vert</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClusterSelectedObjects",

  props: {
    selectedObjects: {
      type: Array,
      required: true
    },

    clusterTool: {
      type: Boolean,
      default: false
    },

    selectionType: {
      type: String,
      required: true
    }
  },

  methods: {
    objectIdentification(object) {
      let label = this.$tc(object.type, 1) + ": ";
      if (object.label) {
        label += object.label;
      } else {
        label += object.id;
      }
      return label;
    },

    openObjectMenu(event, object) {
      this.$emit("openObjectMenu", { event, object });
    }
  }
};
</script>

<style scoped>
.cluster-objects-scroll {
  max-height: 117px;
  overflow: auto;
  scroll-behavior: smooth;
  text-align: left;
}

.cluster-object-hps {
  right: 35px;
  position: absolute;
  cursor: pointer;
  padding: 2px;
  color: rgba(126, 128, 131, 1);
}
.main-closure {
  margin-bottom: 15px;
  margin-top: 5px;
  border-top: 1px solid rgb(177, 177, 177);
  border-bottom: 1px solid rgb(177, 177, 177);
  border-radius: 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Cluster/SelectedObjects.vue